module.exports = __webpack_public_path__ + "img/mapicohotel.png";